import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Dialog } from '@material-ui/core';

import { getChannelPerformanceLabel } from 'src/data/channel';
import { getResourceDocumentLabel, isEmailCsvResourceDocument } from 'src/data/performance';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import improveImg from './assets/improve.svg';
import benchmarkImg from './assets/benchmark.svg';
import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const AccountsDataExtractionNavigationPopup = ({
  open,
  onClose,
  channel,
  projectId,
  variationId,
  variation,
}) => {
  const styles = useStyles();

  const { handleImproveClick, handleBenchmarkClick } = useHandlers({
    channel,
    onClose,
    projectId,
    variationId,
    variation,
  });

  const onlyOneCard = isEmailCsvResourceDocument(channel);

  return (
    <Dialog
      classes={{
        paper: styles.root,
      }}
      open={open}
      onClose={onClose}
      maxWidth="lg"
    >
      <CustomTypography
        className={styles.header}
        variant={TYPOGRAPHY_VARIANT.h1}
      >
        {getChannelPerformanceLabel(channel) || getResourceDocumentLabel(channel)} connected
        successfully!
      </CustomTypography>
      <div className={cx(styles.cards, { [styles.oneCard]: onlyOneCard })}>
        <div
          className={styles.card}
          onClick={handleBenchmarkClick}
        >
          <CustomTypography
            className={styles.title}
            variant={TYPOGRAPHY_VARIANT.semiBold16}
          >
            Benchmark new copy
          </CustomTypography>
          <CustomTypography
            className={styles.subtitle}
            variant={TYPOGRAPHY_VARIANT.paragraph12}
          >
            See how generated text compares with text you
            <br />
            published in the past!
          </CustomTypography>
          <img
            className={styles.img}
            src={benchmarkImg}
            alt=""
          />
        </div>
        {!onlyOneCard && (
          <div
            className={styles.card}
            onClick={handleImproveClick}
          >
            <CustomTypography
              className={styles.title}
              variant={TYPOGRAPHY_VARIANT.semiBold16}
            >
              Improve published copy
            </CustomTypography>
            <CustomTypography
              className={styles.subtitle}
              variant={TYPOGRAPHY_VARIANT.paragraph12}
            >
              Rewrite previously published copy and increase its
              <br />
              performance with AI.
            </CustomTypography>
            <img
              src={improveImg}
              alt=""
            />
          </div>
        )}
      </div>
    </Dialog>
  );
};

AccountsDataExtractionNavigationPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
AccountsDataExtractionNavigationPopup.defaultProps = {};
